import { useTranslation, type TFunction } from '@mint-lib/i18n';
import { agGridTheme } from '@mint-lib/theme';
import { provideGlobalGridOptions as agProvideGlobalGridOptions } from 'ag-grid-community';

const getLocalizedTextByKey = (t: TFunction) => ({
  searchOoo: t('Search'),
  ariaSearchFilterText: t('Search'),
  sortAscending: t('Sort Ascending'),
  sortDescending: t('Sort Descending'),
  sortUnSort: t('Clear Sort'),
  equals: t('Equals'),
  notEqual: t('Not equal'),
  lessThan: t('Less than'),
  lessThanOrEqual: t('Less than or equal'),
  greaterThan: t('Greater than'),
  greaterThanOrEqual: t('Greater than or equal'),
  contains: t('Contains'),
  notContains: t('Does not contain'),
  startsWith: t('Starts with'),
  endsWith: t('Ends with'),
  blank: t('Blank'),
  notBlank: t('Not blank'),
  pinColumn: t('Pin Column'),
  noPin: t('No Pin'),
  pinLeft: t('Pin Left'),
  pinRight: t('Pin Right'),
  autosizeThisColumn: t('Autosize This Column'),
  autosizeAllColumns: t('Autosize All Columns'),
  ungroupAll: t('Un-Group All'),
  columnChooser: t('Choose Columns'),
  resetColumns: t('Reset Columns'),
  columns: t('Columns'),
  filters: t('Filters'),
});

export const useGlobalGridOptions = () => {
  const { t } = useTranslation('@mint-lib/ag-grid');

  agProvideGlobalGridOptions(
    {
      selectionColumnDef: {
        width: 24,
        suppressHeaderContextMenu: true,
      },
      tooltipShowDelay: 0,
      localeText: getLocalizedTextByKey(t),
      theme: agGridTheme,
    },
    'deep',
  );
};
